import { render, staticRenderFns } from "./ChangeOffice.vue?vue&type=template&id=35bbc97d"
import script from "./ChangeOffice.vue?vue&type=script&lang=js"
export * from "./ChangeOffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports